import { fetcher } from "../../utils/fetcher.js";

export const getPushPublicKey = () =>
  fetcher.get("/api/notifications/push/public-key");

export const subscribePush = (subscription) =>
  fetcher.post("/api/notifications/push/subscribe", { subscription });

export const unsubscribePush = (endpoint) =>
  fetcher.post("/api/notifications/push/unsubscribe", { endpoint });
